import type { BannerContent } from "./global-banner.types";

/**
 * Gets the appropriate banner content based on current UTC time
 * @param now - Current date (defaults to new Date() for easier testing)
 * @returns Banner content configuration or null if no active promotion
 */
export function getBannerContent(): BannerContent | null {
  // TODO: Implement Christmas period logic, remember to re-add (now: Date = new Date()) parameter
  return null;
}
